import React, { useEffect, useState } from "react";
import 'moment-timezone';
import $ from 'jquery';
import SessionManager from "../../routes/SessionManager";
import CommonUtils from "../../util/CommonUtils";
import no_image from './../../assets/img/no-image.png';
import ImageResize from "../common/ImageResize";
import Moment from "react-moment";
import { Badge } from "antd";
import LiveCameraFeed from "../modals/LiveCameraFeed";
import AxisLiveCameraFeed from "../modals/AxisLiveCameraFeed";

function LocationCard(props) {
    let sessionMgr = new SessionManager();
    let user = sessionMgr.readCookie('user');

    const [location, setLocation] = useState(null);
    const [site, setSite] = useState(null);
    const [turnOnVideoStreaming, setTurnOnVideoStreaming] = useState(false);

    useEffect(() => {
        populateDefaults();
    }, []);

    const populateDefaults = async () => {
        let _s = await CommonUtils.getSite(props.site_id, user);
        setSite(_s);
        let _l = await CommonUtils.getLocation(props.location_id, { ...user, site_selected: { site_id: props.site_id } });
        setLocation(_l);
    }

    const streamVideo = (e) => {
        setTurnOnVideoStreaming(true);
        resizeVideoContent(e, true);
    }

    const stopVideo = async (e) => {
        await new Promise((resolve, reject) => setTimeout(resolve, 200));
        if ($('#close-player') && $('#close-player').length > 0) {
            $('#close-player').trigger('click');
        }

        setTurnOnVideoStreaming(false);
        resizeVideoContent(e);
    }

    let image = location ? "https://sitesupt-location-data.s3.amazonaws.com/cusr_" + location.customer_id + "/site_" + location.site_id + "/location_" + props.location_id + "/image_" + location.device_id + "_" + location.location_last_pic_pic_time + ".jpg" : no_image;

    let temperature = '';
    let humidity = '';
    let enable_live_mode = false;
    let enable_view_streaming = false;

    if (location) {
        temperature = Math.round(location.location_temperature, 2);
        temperature = temperature === -100 ? '' : temperature + " °F";

        humidity = Math.round(location.location_humidity, 2);
        humidity = humidity === -100 ? '' : humidity + " %";

        enable_view_streaming = user && user.site_selected && (user.site_selected.site_view_streaming === undefined ? true : user.site_selected.site_view_streaming);

        enable_live_mode = location.device_id && location.location_operstatus === 'Connected';
        if (enable_live_mode)
            enable_live_mode = ((location.location_features && location.location_features.includes('s1')) || (['axis'].includes(location.location_device_type)));
    }

    const resizeVideoContent = (e, isStart = false) => {
        $('.col-md-12').find('.video-btn').trigger('click');
        $('.location-card').removeClass('col-md-12').addClass('col-md-4');

        if (isStart)
            $(e.target).closest('.location-card').removeClass('col-md-4').addClass('col-md-12');
    }

    return (
        <React.Fragment>
            <div className={"card m-2 bg-shadow " + ((site && location) ? "cursor-pointer" : "cursor-loading")}>
                <div className="card-body p-0">
                    <ImageResize className={"card-img-top img-fluid d-block " + (!turnOnVideoStreaming ? "" : "hide")} onClick={(e) => (site && location) && streamVideo(e)} src={image || no_image} resize_perc="0.2"></ImageResize>
                    {location && turnOnVideoStreaming ? location.location_device_type ?
                        <AxisLiveCameraFeed closeModal={() => setTurnOnVideoStreaming(false)} site={site} zone={location} user={user}></AxisLiveCameraFeed> :
                        <LiveCameraFeed closeModal={() => setTurnOnVideoStreaming(false)} site={site} zone={location} user={user}></LiveCameraFeed>
                        : <></>
                    }
                    <div className="card-img-overlay-custom text-right p-1">
                        {turnOnVideoStreaming && <button onClick={(e) => turnOnVideoStreaming ? stopVideo(e) : streamVideo(e)} className={enable_live_mode && enable_view_streaming ? "btn btn-xs btn-danger font-size-12 video-btn streaming-btn" : "btn btn-xs btn-danger font-size-12 hide video-btn streaming-btn"}><i className="fa fa-sm fa-circle pr-1" />{turnOnVideoStreaming ? "Stop Streaming" : "View Streaming"}</button>}
                    </div>
                </div>
                {site && location && <div className="card-header text-app">
                    <b className={"font-weight-700"}>
                        <label className="text-primary">{site && site.site_name}</label><br />
                        {location.location_name} &nbsp;
                        {
                            <span data-toggle="tooltip" title={location.location_operstatus === 'Connected' ? 'Active' : 'Inactive'}>
                                <Badge className={location.location_operstatus === 'Connected' ? "fa fa-lg fa-circle text-success" : "fa fa-lg fa-circle text-danger"} />
                            </span>
                        }
                    </b>
                    <span className={location.location_operstatus === 'Connected' ? 'text-success pull-right font-size-12' : 'text-danger pull-right font-size-12'}>
                        <span className="text-primary">
                            {CommonUtils.formatSensorData('temperature', temperature)}
                        </span>
                        <span className="ml-3 text-primary">
                            {CommonUtils.formatSensorData('humidity', humidity)}
                        </span>
                    </span>
                    <div className="text-dark">
                        <span className="font-size-12 font-weight-300">
                            <Moment format="MMM DD, YYYY HH:mm" tz={site.site_iana_timezone}>
                                {location.location_lastupdate}
                            </Moment>
                        </span>
                    </div>
                </div>
                }
            </div>
        </React.Fragment >
    )
}

export default LocationCard;